const dokumente = function () {
  setTimeout(function () {
    setupDocumentLinks();
  }, 500);

  function setupDocumentLinks() {
    $('.yumpu').unbind();
    $('.yumpu').on('click', function (e) {
      e.preventDefault();
      var yumpuResponsiveEmbedded = $(this).attr('data-yumpuembedded');
      loadModalContent(yumpuResponsiveEmbedded);
    });

    $('#doc-modal').unbind();
    $('#doc-modal').on('hidden.bs.modal', function () {
      $('#doc-modal .modal-body .body').html('');
    });
  }

  function loadModalContent(yumpuResponsiveEmbedded) {
    $('#doc-modal .modal-body .body').html(yumpuResponsiveEmbedded);
  }
};

export default dokumente;



// WEBPACK FOOTER //
// ./scripts/barba-views/dokumente.js